import { empty as emptyFilter } from '@utils'

export const BANK_LIST_COLUMNS = [
    {
        dataIndex: 'serialNumber',
        title: '业务流水号',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'flowDirectionText',
        title: '类型',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'operationTime',
        title: '发生时间',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'flowTypeText',
        title: '账户类型',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'oppositeBankName',
        title: '户名',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'oppositeBankCard',
        title: '户号',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'oppositeOrgCodeText',
        title: '开户银行',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'oppositeOrgName',
        title: '开户银行全称',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'amount',
        title: '金额',
        width: 200,
        customRender: val => emptyFilter(val)
    }
]
